export const DEVELOPMENT_HOST = 'localhost:3000';
export const PARCEL_PERFORM_DOMAIN = 'parcelperform.com';
export const TRACKING_PARAM_PARCEL_ID = 'pParcelId';
export const TRACKING_PARAM_PARCEL_IDS = 'pParcelIds';
export const CONNECTING_TO_CONTENTFUL = 'Connecting to enra-2.1';
export const CONNECTING_TO_REDIS = 'Connecting to enra-2.3';
export const PROJECT_ID = 'pmc';
export const PP_PROJECT_ID = 'pp-contentful';
